"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateTotalKnownShares = (workDraft) => {
    var _a;
    return (_a = workDraft === null || workDraft === void 0 ? void 0 : workDraft.originalPublishers.map((op) => { var _a; return (_a = op.publisherShare) !== null && _a !== void 0 ? _a : 0; }).concat(workDraft === null || workDraft === void 0 ? void 0 : workDraft.originalPublishers.flatMap((op) => op.administratorPublishers.map((ap) => { var _a; return (_a = ap.publisherShare) !== null && _a !== void 0 ? _a : 0; }))).reduce((partialSum, a) => partialSum + a, 0)) !== null && _a !== void 0 ? _a : 0;
};
exports.default = calculateTotalKnownShares;
